/**
 * 详细的reducer文件
 */
import { ADD_TODO,RECEIVE_POSTS,FETCH_SUCCEEDED } from "../actionTypes";

const initialState = {
    allIds: [],
    byIds: {},
    list: [],
    data:''
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ADD_TODO: {
            const { id, content } = action.payload;
            return {
                ...state,
                allIds: [...state.allIds, id],
                byIds: {
                    ...state.byIds,
                    [id]: {
                        content,
                        completed: false
                    }
                }
            };
        }
        case RECEIVE_POSTS: {
            const { posts } = action.payload;
            return {
                ...state,
                list:posts
            }
        }
        case FETCH_SUCCEEDED: {
            const data = action.payload.data
            return {
                ...state,
                data:JSON.stringify(data)
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/todos.js